<template>
    <div class="view-wrapper content flex-ui">
        <van-nav-bar
            title="账号与安全"
            left-arrow
            @click-left="$router.go(-1)"
        />
        <div class="grow">
            <van-cell-group class="group-top-margin">
                <van-cell
                    title="手机号"
                    :value="this.$store.state.user.Mobile"
                />
            </van-cell-group>
            <van-cell-group title="社交平台账号绑定">
                <van-cell title="微信">
                    <template #extra>
                        <van-tag v-if="user.WxBind" plain type="danger" @click="removeBind('wx')">解绑</van-tag>
                        <van-tag v-else plain type="warning">未绑定</van-tag>
                    </template>
                </van-cell>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: {},
        };
    },
    created() {
        this.loadUser();
    },
    methods: {
        loadUser() {
            this.$ajax
                .get("api/user/new")
                .then((response) => {
                    if (response.data.code === 1) {
                        this.user = response.data.data;
                    } else {
                        //失败
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        removeBind(type) {
            this.$ajax
                .post("api/user/bind/remove/" + type)
                .then((response) => {
                    if (response.data.code === 1) {
                        if (response.data.data) {
                            this.user.WxBind = false;
                        }
                    } else {
                        //失败
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>

<style lang="less" scoped></style>
